export default __webpack_public_path__ + "static/media/courses3.9303cf73.svg";